import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Create axios instance
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add token to requests if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('multicell_admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Products API
export const productsAPI = {
  getAll: (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.brand) params.append('brand', filters.brand);
    if (filters.condition) params.append('condition', filters.condition);
    if (filters.minPrice) params.append('min_price', filters.minPrice);
    if (filters.maxPrice) params.append('max_price', filters.maxPrice);
    if (filters.featured !== undefined) params.append('featured', filters.featured);
    if (filters.search) params.append('search', filters.search);
    
    return api.get(`/products?${params.toString()}`);
  },
  
  getById: (id) => api.get(`/products/${id}`),
  
  create: (productData) => api.post('/products', productData),
  
  update: (id, productData) => api.put(`/products/${id}`, productData),
  
  delete: (id) => api.delete(`/products/${id}`),
  
  compare: (productIds) => api.post('/products/compare', productIds)
};

// Brands API
export const brandsAPI = {
  getAll: () => api.get('/brands')
};

// Admin API
export const adminAPI = {
  login: (username, password) => 
    api.post('/admin/login', { username, password }),
  
  verify: () => api.get('/admin/verify')
};

export default api;